import { MenuItem, Select } from '@mui/material'

type Props = {
  column: any
  label?: string
  width?: number
}

export const FilterStatus = ({
  column,
  label = 'Alle',
  width = 130,
}: Props) => {
  const { filterValue, setFilter } = column
  const NO_FILTER = 'all'

  const data = [
    { label: 'Grün', value: 'green' },
    { label: 'Gelb', value: 'yellow' },
    { label: 'Rot', value: 'red' },
  ]

  const onChange = event => {
    const value = event.target.value

    setFilter(value === NO_FILTER ? undefined : value || undefined)
  }

  const value = filterValue ?? NO_FILTER

  return (
    <Select onChange={onChange} sx={{ width }} value={value}>
      <MenuItem value={NO_FILTER}>{label}</MenuItem>

      {data.map(item => (
        <MenuItem key={item.value} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </Select>
  )
}
